import { UserManager } from 'oidc-client-ts';

let _userManager: UserManager | null = null;

export function setUserManager(manager: UserManager): void {
  _userManager = manager;
}

export function getUserManager(): UserManager | null {
  return _userManager;
}
